import {Component, OnInit, Input, Output, EventEmitter} from "@angular/core";
import {Subject} from "rxjs";
import {SelectorService, SelectorItem, SelectorDisplay} from "./selector";

@Component({
  selector: 'app-selector',
  templateUrl: 'selector.component.html',
  styleUrls: ['selector.component.scss']
})
export class SelectorComponent implements OnInit {

  @Input() initItem: SelectorItem;
  @Input() service: SelectorService;
  @Input() display: SelectorDisplay;
  @Output() onChanged = new EventEmitter<any>();

  item: SelectorItem;
  items: SelectorItem[];

  searchTerms = new Subject<string>();

  isOpen: boolean = false;
  searching: boolean = false;

  constructor() {
    this.searchTerms.debounceTime(500).distinctUntilChanged().subscribe(
      term => this.get(term)
    )
  }

  ngOnInit() {
    this.item = this.initItem;
  }

  get(term: string) {
    if(term.trim().length === 0) {
      return;
    }

    this.searching = true;
    this.service.searchTerm(term).subscribe(
      items => this.items = items, error => error, () => this.searching = false
    );
  }

  toggle() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.get('');
    } else {

    }
  }

  search(term: string): void {
    this.searchTerms.next(term);
  }

  select(item: any) {
    this.item = item;
    this.isOpen = false;
    this.onChanged.emit(this.item);
  }

  itemDisplay(item: any): string {
    if(this.display && item)
      return this.display(item);
    return '닉네임,소속,담당 업무로 검색 가능';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/selector/selector.component.ts